




















































import Vue from 'vue';
import Component from 'vue-class-component';
import {UserModel, UserProfileModel} from '@/models/user.model';
import {publicProfileModule, publicProfileState, userModule} from '@/utils/store-acessor';

@Component({})
export default class ProfileAbout extends Vue {
  @userModule.Getter('profile') profile!: UserProfileModel;
  @publicProfileModule.Getter('publicProfile')
  publicProfile!: UserModel;

  profileAbout: string | undefined = '';
  profileName: string | undefined = '';
  loading: boolean = false;
  isPublic: boolean = false;
  publicAboutLoading: boolean = false;

  async mounted() {
    this.isPublic = this.$route.params.slug !== 'me';
    if (this.$route.params.slug === 'me') {
      this.profileAbout = this.profile?.about;
    } else {
      this.publicAboutLoading = true;
      if (!this.publicProfile?.id) {
        await publicProfileState.fetchPublicProfile(this.$route.params.slug);
      }
      this.profileAbout = this.publicProfile?.user_profile?.about;
      this.profileName = this.publicProfile?.full_name;
      this.publicAboutLoading = false;
    }
  }
}
